import React from 'react';
import { getRepresentativeKeyId, user_type_paragraph, user_type_title } from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import Table from '../components/Table/Table';

const Panel_E02_UserTypes = ({
  onStepPressed,
  onConfigChanged,
  globJSON,
  selectedScreen,
  language,
}) => {
  const { screens_ordering } = globJSON.configurations.services;
  const { deliverables } = globJSON.configurations;
  const { user_types } = deliverables;
  const allSelectedServices = screens_ordering.filter((serviceId) => globJSON.configurations.services[serviceId].selected);
  const allServices = [];
  allSelectedServices.forEach((serviceId) => allServices.push(globJSON.configurations.services[serviceId].name));
  return (
    <FullPagePanel
      globJSON={globJSON}
      selectedScreen={selectedScreen}
      onConfigChanged={onConfigChanged}
      onStepPressed={onStepPressed}
      panelHeadline={user_type_title}
      paragraph={user_type_paragraph}
      tooltipsTitles={deliverables.screens_ordering}
      disableEditElements
      language={language}
      paddingVertical={25}
    >
      <Table
        allServices={allServices}
        userTypes={user_types.userTypes}
        onConfigChanged={onConfigChanged}
      />
    </FullPagePanel>
  );
};

export default Panel_E02_UserTypes;
